import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SubmenuComponent } from './components/submenu/submenu.component';
import { MessageComponent } from './components/message/message.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CallbackComponent } from './components/callback/callback.component';
import { HeaderComponent } from './components/header/header.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ListComponent } from './components/users/list/list.component';
import { EditComponent } from './components/users/edit/edit.component';
import { FormListComponent } from './components/forms/form-list/form-list.component';
import { LayoutListComponent } from './components/forms/layout-list/layout-list.component';
import { MasterListComponent } from './components/forms/master-list/master-list.component';
import { AddFormComponent } from './components/forms/add-form/add-form.component';
import {APP_BASE_HREF} from '@angular/common';
import { SSOLoginComponent } from './ssologin/ssologin.component';
import { EditorRedirectComponent } from './editor-redirect/editor-redirect.component';
import { EditRoleComponent } from './components/roles/edit-role/edit-role.component';
import { ListRoleComponent } from './components/roles/list-role/list-role.component';
import { NavigationNodeListComponent } from './components/navigation/navigation-node-list/navigation-node-list.component';
import { NavigationNodeFormComponent } from './components/navigation/navigation-node-form/navigation-node-form.component';
import { NavigationRuleListComponent } from './components/navigation/navigation-rule-list/navigation-rule-list.component';
import { NavigationRuleFormComponent } from './components/navigation/navigation-rule-form/navigation-rule-form.component';
import { UserSearchSettingListComponent } from './components/searchsettings/user-search-setting-list/user-search-setting-list.component';
import { UserSearchSettingFormComponent } from './components/searchsettings/user-search-setting-form/user-search-setting-form.component';
import { FormactionListComponent } from './components/formaction/formaction-list/formaction-list.component';
import { FormactionFormComponent } from './components/formaction/formaction-form/formaction-form.component';

export function HttpLoaderFoctory(http:HttpClient){
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    SubmenuComponent,
    MessageComponent,
    DashboardComponent,
    CallbackComponent,
    HeaderComponent,
    ListComponent,
    EditComponent,
    FormListComponent,
    LayoutListComponent,
    MasterListComponent,
    AddFormComponent,
    SSOLoginComponent,
    EditorRedirectComponent,
    EditRoleComponent,
    ListRoleComponent,
    NavigationNodeListComponent,
    NavigationNodeFormComponent,
    NavigationRuleListComponent,
    NavigationRuleFormComponent,
    UserSearchSettingListComponent,
    UserSearchSettingFormComponent,
    FormactionListComponent,
    FormactionFormComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader:{
        provide: TranslateLoader,
        useFactory: HttpLoaderFoctory,
        deps: [HttpClient]
      }
   })
  ],
  providers: [{provide: APP_BASE_HREF, useValue: '/platform/app'}, HttpClientModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
